.ca{display:inline-flex;}